module.exports = __webpack_public_path__ + "static/media/mural_concept_for_bbq_restaurant_classic_cartoon_style_2017.95073356.webp";